/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// 🔔 useNotifications — accessor over the notifications Pinia store.
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Surfaces (bell dropdown, toast container, /notifications page) all
/// import from here so the underlying store can change shape without
/// every consumer re-importing it.

import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '~/stores/notificationsStore'

export const useNotifications = () => {
  const store = useNotificationsStore()
  const {
    notifications,
    visible,
    unread,
    unreadCount,
    criticalCount,
    hydrated,
    dismissedIds,
  } = storeToRefs(store)

  return {
    // reactive refs
    notifications,
    visible,
    unread,
    unreadCount,
    criticalCount,
    hydrated,
    /** Set of notification IDs the active user has dismissed. The
     *  cost-anomalies card on the overview cross-references this
     *  to filter out anomalies whose persisted notification has
     *  been swiped away — so a dismissal sticks across page
     *  refreshes / Snowflake re-fetches. */
    dismissedIds,
    // actions (always read live state via the store)
    markRead: store.markRead,
    markAllRead: store.markAllRead,
    dismiss: store.dismiss,
    consumeToast: store.consumeToast,
    // lifecycle (used by the auth wiring + the layout)
    bind: store.bind,
    teardown: store.teardown,
  }
}
